import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonAction, TopButtonPointAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import acc from 'accounting'
import FakturyBiletyService from "../FakturyBiletyService";
import {TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";

export default class FakturyBiletyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fakturaDoModala: null,
            pozycjeFaktury: null,
            showModal: false,
            setLoader: false,
            czyError: false,
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.pobierzPozycjeFaktury = this.pobierzPozycjeFaktury.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointAction onClick={() => {
                    this.pobierzPozycjeFaktury(row)
                }} buttonIcon={'fa fa-list'} buttonColor={'default'} titleContent={'Zobacz pozycje'}/>
            </div>
        )
    }

    pobierzPozycjeFaktury(faktura) {
        this.setState({
            fakturaDoModala: faktura,
            showModal: true,
            setLoader: true,
            czyError: false,
        })

        FakturyBiletyService.pobierzPozycjeFaktury(faktura.rok, faktura.mies, faktura.symbDokMag, faktura.numDokMag)
            .then(function (response) {
                console.log(response)
                if (response.status < 300) {
                    this.setState({
                        pozycjeFaktury: response.data,
                        showModal: true,
                        setLoader: false,
                        czyError: false,
                    })
                } else {
                    this.setState({
                        pozycjeFaktury: null,
                        showModal: true,
                        setLoader: false,
                        czyError: true,
                    })
                }

            }.bind(this))
            .catch(function (error) {
                this.setState({
                    pozycjeFaktury: null,
                    showModal: true,
                    setLoader: false,
                    czyError: true,
                })
            }.bind(this))

    }

    formatTyp(cell, row) {
        return <span style={{fontSize: '12px'}}>{cell === 'Z' ? 'jedn.' : 'mies.'}</span>
    }

    formatDaty(cell, row) {
        return (<div>
            <div>
                <span style={{fontSize: '12px'}}>Data wystawienia:</span><span style={{fontWeight: 'bold'}}>{' ' + cell}</span>
            </div>
            <div style={{color: 'grey', fontSize: '12px'}}>
                Data sprzedaży: <span style={{fontWeight: 'bold'}}>{row.dataSp}</span>
            </div>
            <div style={{color: 'grey', fontSize: '12px'}}>
                Termin płatności: <span style={{fontWeight: 'bold'}}>{row.termPl}</span>
            </div>
        </div>)
    }

    formatKontrahent(cell, row) {
        if (row.nipOdbiorcyPeselKl || !row.czyFirma) {
            return cell
        } else {
            return (<div>
                {cell}
                <div style={{color: 'grey', fontSize: '10px', fontStyle: 'italic'}}><i className={'fa fa-info-circle'}></i> Odbiorca</div>
            </div>)
        }
    }

    formatNIP(cell, row) {
        if (row.nipOdbiorcyPeselKl || !row.czyFirma) {
            return cell
        } else {
            return (<div>
                {row.nipNabywcy}
                <div style={{color: 'grey', fontSize: '10px', fontStyle: 'italic'}}><i className={'fa fa-info-circle'}></i> Nip nabywcy</div>
            </div>)
        }
    }

    expandComponent(row) {

        return <div style={{borderBottom: '3px solid #83c33a', paddingBottom: '5px'}}>
            <div className={'well well-sm'} style={{marginBottom: '5px'}}>
                {
                    Boolean(row.info1) ?
                        <div>
                            Info: {row.info1}
                        </div>
                        :
                        ''
                }{
                Boolean(row.uwagi) ?
                    <div>
                        Uwagi: {row.uwagi}
                    </div>
                    :
                    ''
            }
            </div>
        </div>

    }

    expandColumnComponent({isExpandableRow, isExpanded}) {
        let content = '';

        if (isExpandableRow) {
            content = (isExpanded ?
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-up'></i>)
                    :
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-down'></i>)
            )
        } else {
            content = ' ';
        }
        return (
            <div> {content} </div>
        );
    }

    isExpandableRow(row) {
        return (Boolean(row.uwagi) || Boolean(row.info1))
    }

    renderOdcinekPozycja(cell, row) {
        return (<div>
            <div><span className={'label label-ebus-default'}>{row.trasa_nazwa}</span></div>
            <div>{cell}</div>
        </div>)
    }


    render() {

        let typy = {
            'Z': 'jednorazowy',
            'M': 'miesięczny'
        }

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',
            expandBy: 'column'
        };
        return (
            <div>
                <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                    Ilość wszystkich logów: {this.props.data.length}
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    pagination
                                    hover
                                    expandableRow={this.isExpandableRow}
                                    expandComponent={this.expandComponent}
                                    expandColumnOptions={{
                                        expandColumnVisible: true,
                                        expandColumnComponent: this.expandColumnComponent,
                                        columnWidth: 30,
                                    }}
                    >
                        <TableHeaderColumn dataField='nrFaktury' isKey dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}

                        >Nr faktury</TableHeaderColumn>
                        <TableHeaderColumn dataField='dataWys' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.formatDaty}
                                           expandable={false}
                        >Data wystawienia</TableHeaderColumn>
                        <TableHeaderColumn dataField='kontrahent' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.formatKontrahent}
                                           expandable={false}
                        >Odebrał</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazwaKlFi' dataSort
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           expandable={false}
                        >Firma / Klient</TableHeaderColumn>
                        <TableHeaderColumn dataField='nipOdbiorcyPeselKl' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           expandable={false}
                                           dataFormat={this.formatNIP}
                        >NIP / PESEL</TableHeaderColumn>
                        <TableHeaderColumn dataField='netto8' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           expandable={false}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Netto</TableHeaderColumn>
                        <TableHeaderColumn dataField='vat8' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           expandable={false}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >VAT</TableHeaderColumn>
                        <TableHeaderColumn dataField='kwota' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           expandable={false}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Kwota</TableHeaderColumn>
                        <TableHeaderColumn dataField='typBiletu' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'SelectFilter', options: typy, selectText: ''}} formatExtraData={typy}
                                           dataFormat={this.formatTyp}
                                           expandable={false}
                        >Typ</TableHeaderColumn>
                        <TableHeaderColumn dataField='wystawil' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           expandable={false}
                        >Wystawił</TableHeaderColumn>
                        <TableHeaderColumn dataField='nrFaktury'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={this.renderButtonyAkcji}
                                           expandable={false}
                        >Zobacz pozycje</TableHeaderColumn>
                    </BootstrapTable>
                </div>
                <div>

                    {
                        this.state.showModal ?
                            <div id={'EBUSModalContainerBG'}>
                                <div id={'modalContainer'} className={'modalFakturaDuzy'}>
                                    <div id={'modalTextContent'}>
                                        <div>
                                            <div className={'pull-right'}>
                                                <TopButtonAction onClick={() => {
                                                    this.setState({
                                                        fakturaDoModala: null,
                                                        pozycjeFaktury: null,
                                                        showModal: false,
                                                        setLoader: false,
                                                        czyError: false,
                                                    })
                                                }}
                                                                 elementStyle={{color: 'firebrick'}}
                                                                 btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                                />
                                            </div>
                                            <div style={{clear: 'both', height: '5px'}}></div>
                                            <div>
                                                {
                                                    this.state.setLoader ?
                                                        <div>
                                                            <div id={'smallLoader'}>
                                                                <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                                                <div>Trwa ładowanie danych...</div>
                                                            </div>
                                                        </div>
                                                        :
                                                        this.state.czyError ?
                                                            <TopAlertUwaga text={'Wystąpił błąd - nie można pobrać pozycji faktury'}/>
                                                            :
                                                            <div>
                                                                <div>
                                                                    <div>
                                                                        <h4>Pozycje z faktury nr <span style={{fontSize: 'inherit'}}
                                                                                                       className={'label label-ebus-primary'}>{this.state.fakturaDoModala.nrFaktury}</span> za
                                                                            bilet {(this.state.fakturaDoModala.typBiletu === 'M') ? 'miesięczny' : 'jednorazowy'}
                                                                        </h4>
                                                                    </div>
                                                                    {
                                                                        (this.state.fakturaDoModala.typBiletu === 'M') ?
                                                                            <BootstrapTable data={this.state.pozycjeFaktury}
                                                                                            hover
                                                                            >
                                                                                <TableHeaderColumn dataField='id_bm' isKey dataSort
                                                                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >ID biletu</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='nazwa' dataSort
                                                                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Nazwa</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='nr_karty' dataSort
                                                                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Numer karty</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='wazny_od' dataSort
                                                                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Ważny od</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='wazny_do' dataSort
                                                                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Ważny do</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='miejscowosc_od_do' dataSort
                                                                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                                   dataFormat={this.renderOdcinekPozycja}
                                                                                >Odcinek</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='kierunek' dataSort
                                                                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                                   dataFormat={(cell, row) => {
                                                                                                       if (cell == 2) return 'w obie strony';
                                                                                                       else return 'w jedną stronę'
                                                                                                   }}
                                                                                >Kierunek</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='naz_znizki' dataSort
                                                                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Nazwa zniżki</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='wartosc_brutto' dataSort
                                                                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                                   dataFormat={(cell, row) => {
                                                                                                       return acc.formatMoney(cell)
                                                                                                   }}
                                                                                >Wartość brutto</TableHeaderColumn>
                                                                            </BootstrapTable>
                                                                            :
                                                                            <BootstrapTable data={this.state.pozycjeFaktury}
                                                                                            hover
                                                                            >
                                                                                <TableHeaderColumn dataField='id_bp' isKey hidden={true}
                                                                                >id_bp</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='id_bi' dataSort
                                                                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >ID biletu</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='nazwa' dataSort
                                                                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Nazwa</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='wazny_od' dataSort
                                                                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Ważny od</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='godz' dataSort
                                                                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Godz</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='miejscowosc_od_do' dataSort
                                                                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                                   dataFormat={this.renderOdcinekPozycja}
                                                                                >Odcinek</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='id_ku' dataSort
                                                                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Kurs</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='klient' dataSort
                                                                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Pasażer</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='naz_znizki' dataSort
                                                                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Nazwa zniżki</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='ilosc' dataSort
                                                                                                   thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                >Ilość</TableHeaderColumn>
                                                                                <TableHeaderColumn dataField='wartosc_brutto' dataSort
                                                                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                                                                   filter={{
                                                                                                       type: 'TextFilter',
                                                                                                       delay: 500,
                                                                                                       placeholder: 'Szukaj'
                                                                                                   }}
                                                                                                   dataFormat={(cell, row) => {
                                                                                                       return (<div>
                                                                                                           <div>{acc.formatMoney(cell * row.ilosc)}</div>
                                                                                                           <div style={{fontSize:'12px', color:'grey'}}>
                                                                                                               {acc.formatMoney(cell)}/szt
                                                                                                           </div>
                                                                                                       </div>)
                                                                                                   }}
                                                                                >Wartość brutto</TableHeaderColumn>
                                                                            </BootstrapTable>
                                                                    }
                                                                </div>

                                                            </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div style={{clear: 'both'}}></div>
                                </div>
                            </div>
                            :
                            ''

                    }


                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/fakturyBilety/components/FakturyBiletyTable.js